import moment from 'moment';
import { MeasurementDate, MeasurementDates } from 'common/types/measurementDate';
import { shortDate } from 'utilities/dateFormats';
import { getArrayValue } from 'utilities/getArrayValue';

const isValidDate = (date: Date | string) => {
  const formats = [moment.ISO_8601];

  return moment(date, formats, true).isValid();
};

const formatMeasurementDates = (measurementDates: MeasurementDates) => {
  const formattedMeasurementDates = getArrayValue(
    measurementDates?.map(measurementDate => {
      const { name, id } = measurementDate;

      const formattedName = name && isValidDate(name) ? (shortDate(name) as unknown as Date) : name;

      // Map null IDs (like "Most Recent") to a string identifier for dropdown compatibility
      const formattedId = id === null || id === undefined ? 'most-recent' : id;

      return { ...measurementDate, name: formattedName, id: formattedId } as MeasurementDate;
    })
  );

  return formattedMeasurementDates;
};

export default formatMeasurementDates;
